import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadPricingProfileListEpic } from './_epics/loadPricingProfileList.epic';
import { createPricingProfileEpic } from './_epics/createPricingProfile.epic';
import { updatePricingProfileEpic } from './_epics/updatePricingProfile.epic';
import { removePricingProfileEpic } from './_epics/removePricingProfile.epic';
import { exportPricingProfileEpic } from './_epics/exportPricingProfile.epic';

export const pricingProfileEpic = safeCombineEpics(
  loadPricingProfileListEpic,
  createPricingProfileEpic,
  updatePricingProfileEpic,
  removePricingProfileEpic,
  exportPricingProfileEpic,
);
